export const GENERIC_ERROR = {
    title: 'There’s been a problem',
    body: 'Something went wrong, please try again',
    ctaTitle: 'OK',
}

export const EACHWAY_UNAVAILABLE = {
    title: 'EW not available',
    body: 'Each Way is not available for this race',
    ctaTitle: 'OK',
}

export const ENTER_STAKE = {
    title: 'Please enter stake',
    body: 'You must enter at least one stake to place a bet',
    ctaTitle: 'OK',
}

export const BOG_UNAVAILABLE = {
    title: 'There’s been a problem',
    body: 'The best odds guarantee is not available for this selection, please try again later',
    ctaTitle: 'OK',
}



// WEBPACK FOOTER //
// /src/js/common/globalModal/modalMessages.js